import Sdata from '@/database/sdata'

let g_entity = 'member_machine'
let g_url    = 'studio/machine'
let g_pkey   = ['uid']
Sdata.addConfig( g_entity, g_pkey, g_url )

export default class Machine extends Sdata
{
  static entity = g_entity
  static url    = g_url
}